function getDeviceId() {
	// Check if the device ID is already stored in localStorage
	let deviceId = localStorage.getItem('deviceId')

	// If not, generate a new one
	if (!deviceId) {
		deviceId = 'device_' + Math.random().toString(36).substring(2, 12)
		localStorage.setItem('deviceId', deviceId)
	}

	return deviceId
}

export default getDeviceId
